import { useQuery } from '@tanstack/react-query';
import { customerService } from '../api/services/customerService';

export function useCustomers() {
  return useQuery({
    queryKey: ['customers'],
    queryFn: customerService.getAllCustomers,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
}

export function useCustomer(customerId: string) {
  return useQuery({
    queryKey: ['customer', customerId],
    queryFn: () => customerService.getCustomerById(customerId),
    enabled: !!customerId,
    staleTime: 5 * 60 * 1000,
  });
}
